import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './Categoryreturn.css';
import Pagination from '../../CommonUI/Pagination/Pagination';
import MarketMF from "../MarketMF";
import { Vortex } from 'react-loader-spinner'

function Categoryreturn() {
    const [data, setData] = useState([]);

    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState("Equity");
    const [loadingshow, setloadingshow] = useState(false);
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;

    useEffect(() => {
        setloadingshow(true);
        const getUrl = BaseURL + "Categoryinner";
        if (groupValue === "Equity") {

            fetch(`${getUrl}/${groupValue}/GROWTH/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        } else {
            // const getUrl = BaseURL + "Categoryinner";
            fetch(`${getUrl}/${groupValue}/GROWTH/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    // console.log(getData, "getData")
                })
                .catch((error) => {
                });
        }

        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, [groupValue]);




    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);

    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/mutual-funds">Mutual Fund</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Category Return</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='Categoryretun-loser-sc'>
                            <div className='Categoryretun-header'>
                                <h2><span>Category Returns</span></h2>
                            </div>
                            <MarketMF optionValue="Category Return" />
                            <div className='Categoryretun-right'>
                                <div className='Categoryretun-inner-select'>
                                    
                                    {/* aria-label="Equity Debt" */}
                                    <select aria-label="Equity Debt" onChange={(event) => { setGroupValue(event.target.value); }}>
                                        <option value="Equity" selected>Equity</option>
                                        <option value="Debt">Debt</option>
                                        <option value="hybrid">hybrid</option>

                                    </select>
                                </div>

                            </div>

                            <div className='Categoryretun-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left'>CATEGORY</th>
                                            <th className='text-right'>1 WEEK%</th>
                                            <th className='text-right'>1 MONTH%</th>
                                            <th className='text-right'>3 MONTHS%</th>
                                            <th className='text-right'>6 MONTHS%</th>
                                            <th className='text-right'>1 YEAR%</th>
                                            <th className='text-right'>3 YEARS%</th>
                                            <th className='text-right'>5 YEARS%</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ typename, ret1w, ret1m, ret3m, ret6m, ret1y, ret3y, ret5y }) => (
                                                <tr>
                                                    <td className="text-left">{typename} </td>
                                                    <td><div className={ret1w > 0 ? "textGreen text-right" : "textRed text-right"}>{ret1w != null ? ret1w.toFixed(2) : 0}</div></td>
                                                    <td><div className={ret1m > 0 ? "textGreen text-right" : "textRed text-right"}> {ret1m != null ? ret1m.toFixed(2) : 0}</div></td>
                                                    <td><div className={ret3m > 0 ? "textGreen text-right" : "textRed text-right"}> {ret3m != null ? ret3m.toFixed(2) : 0}</div></td>
                                                    <td><div className={ret6m > 0 ? "textGreen text-right" : "textRed text-right"}> {ret6m != null ? ret6m.toFixed(2) : 0}</div></td>
                                                    <td><div className={ret1y > 0 ? "textGreen text-right" : "textRed text-right"}> {ret1y != null ? ret1y.toFixed(2) : 0}</div></td>
                                                    <td><div className={ret3y > 0 ? "textGreen text-right" : "textRed text-right"}> {ret3y != null ? ret3y.toFixed(2) : 0}</div></td>
                                                    <td><div className={ret5y > 0 ? "textGreen text-right" : "textRed text-right"}> {ret5y != null ? ret5y.toFixed(2) : 0}</div></td>

                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Categoryreturn;